export const customSort = <A = any, B = any>(
    originalList: Array<A>,
    customSortList: Array<B>,
    originalListValueGetter?: (value: A) => string | number,
    customSortListValueGetter?: (value: B) => string | number
) => {
    originalList.sort((valueA, valueB) => {
        const value1 = originalListValueGetter ? originalListValueGetter(valueA) : valueA;
        const value2 = originalListValueGetter ? originalListValueGetter(valueB) : valueB;

        let index1 = -1;
        let index2 = -1;

        customSortList.forEach((customSortValue, index) => {
            const value = customSortListValueGetter ? customSortListValueGetter(customSortValue) : customSortValue;
            if (value === value1) {
                index1 = index;
            }
            if (value === value2) {
                index2 = index;
            }
        });

        if (index1 === -1) {
            return 1;
        }

        if (index1 < index2 || index2 === -1) {
            return -1;
        }

        return 0;
    });
};
